// ANGULAR
import { OverlayModule } from '@angular/cdk/overlay';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// PERFECT SCROLL BAR
import { TranslateModule } from '@ngx-translate/core';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

// HAMMER JS
import 'hammerjs';

// NGX PERMISSIONS
import { NgxPermissionsModule } from 'ngx-permissions';

// // log rocket
// import LogRocket from 'logrocket';

// LAYOUT SERVICES
import {
  LayoutConfigService,
  SplashScreenService,
} from './@metronic/core/_base/layout';

// CONFIG
import { LayoutConfig } from './@metronic/core/_config/layout.config';

// INTERCEPTORS
import { AuthInterceptor } from './core/interceptors/auth-interceptor';

// MODULES
import { CoreModule } from './modules/core/core.module';
import { UiModulesRouting } from './modules/ui-modules-routing.module';
import { StateModule } from './state/state.module';
import { SortablejsModule } from 'ngx-sortablejs';
// import { QuillModule } from 'ngx-quill';

// COMPONENTS
import { SplashScreenComponent } from './@metronic/views/partials/layout';
import { AppComponent } from './app.component';

// tslint:disable-next-line:class-name
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  wheelSpeed: 0.5,
  swipeEasing: true,
  minScrollbarLength: 40,
  maxScrollbarLength: 300,
};

export function initializeLayoutConfig(appConfig: LayoutConfigService) {
  // initialize app by loading default demo layout config
  return () => {
    if (appConfig.getConfig() === null) {
      appConfig.loadConfigs(new LayoutConfig().configs);
    }
  };
}

// LogRocket.init('saeculum-solutions/iqcheckpoint');
@NgModule({
  declarations: [AppComponent, SplashScreenComponent],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CoreModule,
    UiModulesRouting,
    HttpClientModule,
    OverlayModule,
    StateModule,
    NgxPermissionsModule.forRoot(),
    TranslateModule.forRoot(),
    SortablejsModule.forRoot({ animation: 150 }),
    // QuillModule.forRoot()
  ],
  exports: [],
  providers: [
    // Angular 21 defaults to zoneless CD even for NgModule bootstrap; the A8 app
    // relied on zone.js automatic CD after async work (HTTP callbacks, timers).
    // This restores the exact Angular 8 change-detection model (plan §6.2).
    // Event coalescing stays OFF (the A8 default).
    provideZoneChangeDetection(),
    LayoutConfigService,
    SplashScreenService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    {
      // layout config initializer
      provide: APP_INITIALIZER,
      useFactory: initializeLayoutConfig,
      deps: [LayoutConfigService], multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}

